import React from 'react';
export function BrazilianJiuJitsu() {
  return <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 text-center" data-id="element-338">
      <h1 className="text-4xl font-bold text-gray-900 mb-4" data-id="element-339">
        Brazilian Jiu-Jitsu
      </h1>
      <p className="text-xl text-gray-600" data-id="element-340">Program Content Coming Soon</p>
    </div>;
}